import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../static/styles/CannonClashInstructions.module.css'; // Reusing same styles

const AimTrainInstructions = ({ isOpen, onClose }) => {
    const navigate = useNavigate();

    if (!isOpen) return null;

    const handleTournamentsNavigation = () => {
        onClose();
        navigate('/tournaments');
    };

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h2>AimTrain Tournament Instructions</h2>
                    <button className={styles.closeButton} onClick={onClose}>×</button>
                </div>

                <div className={styles.content}>
                    <div className={styles.section}>
                        <h3>How to Join Tournament</h3>
                        <ol>
                            <li><strong>Join the Tournament</strong> - Click "Join Now" to register</li>
                            <li><strong>Receive Tournament Details</strong> - One hour before the tournament starts, you will receive an SMS containing:
                                <ul>
                                    <li>Your Room ID</li>
                                    <li>Your Match Time</li>
                                </ul>
                            </li>
                            <li><strong>Enter the Match</strong> - At your allotted match time:
                                <ol>
                                    <li>Navigate to the tournaments page: <span onClick={handleTournamentsNavigation} className={styles.tournamentLink}>https://jazzesl.com.pk/tournaments</span></li>
                                    <li>Click the "Play Now" button on your tournament</li>
                                    <li>Enter the Room ID received via SMS in the popup</li>
                                    <li>Click "Submit" to start the game</li>
                                </ol>
                            </li>
                            <li><strong>Game Setup</strong> - The game will automatically connect you to a multiplayer match</li>
                            <li><strong>Game Controls</strong>
                                <ul>
                                    <li>Desktop: Use mouse to aim and click to shoot</li>
                                    <li>Mobile: Touch to aim and tap to shoot</li>
                                </ul>
                            </li>
                            <li><strong>Objective</strong>
                                <ul>
                                    <li>Eliminate your opponent in a 1v1 battle to proceed to the next round</li>
                                    <li>Survive to the last round and win to earn the credits</li>
                                </ul>
                            </li>
                        </ol>
                    </div>

                    <div className={styles.section}>
                        <h3>Tournament Rules</h3>
                        <ul>
                            <li><strong>Tournament Format:</strong> Progressive multiplayer tournament</li>
                            <li><strong>Joining a Match:</strong> You will receive an SMS with your Room ID and Match Time</li>
                            <li><strong>No-Show Rule:</strong> If you don't join within the time limit, you'll be eliminated</li>
                            <li><strong>Progression:</strong> Top performers advance to next rounds</li>
                            <li><strong>Next Rounds:</strong> Scheduled the following day at the same time, with new Room ID via SMS</li>
                            <li><strong>Tournament Continuation:</strong> Rounds continue until final winner is determined</li>
                            <li><strong>Rewards:</strong> Winner's reward will be instantly credited to their Jazz ESL wallet</li>
                        </ul>
                    </div>

                    <div className={styles.section}>
                        <h3>Important Notes</h3>
                        <ul>
                            <li>No download required - play directly on the Jazz ESL web page</li>
                            <li>Missing your match results in elimination</li>
                            <li>Eliminated players cannot rejoin the same tournament</li>
                            <li>Number of rounds depends on total participants</li>
                            <li>Ensure stable internet connection for best experience</li>
                        </ul>
                    </div>
                </div>

                <div className={styles.footer}>
                    <button className={styles.okButton} onClick={onClose}>Got it!</button>
                </div>
            </div>
        </div>
    );
};

export default AimTrainInstructions;